<template>
  <div class="px-1">
    <v-chip outline class="transparent">
      <v-icon left class="text-vertical-middle">
        {{ opportunity.publishedAt && organization.publishedAt ? 'mdi-eye' : 'mdi-eye-off' }}
      </v-icon>
      <span v-if="opportunity.published">
        Published at {{ new Date(opportunity.publishedAt) | date("h:mm a, MMM do yyy") }}
        ({{ new Date(opportunity.publishedAt) | inWords({ addSuffix: true }) }})
      </span>
      <span v-if="!organization.publishedAt">
        The Organization is not published, therefore the opportunity is not published
      </span>
      <span v-else-if="!opportunity.publishedAt"> The Opportunity is not published </span>
    </v-chip>

    <v-btn
      v-if="!opportunity.publishedAt"
      :color="themes.client.light.successButton"
      @click="publishing = true"
    >
      Publish
    </v-btn>

    <v-btn v-else @click="unpublishing = true" :color="themes.client.light.warningButton">
      Unpublish
    </v-btn>

    <!-- PUBLISH -->
    <v-dialog v-model="publishing" max-width="400px">
      <v-card>
        <v-card-title class="title" :color="themes.client.light.dialogTitle">
          Publish opportunity
        </v-card-title>
        <v-divider />
        <v-card-text>
          Are you sure you would like to make the opportunity publicly visible?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn flat @click="publishing = false" :color="themes.client.light.cancel">Cancel</v-btn>
          <v-btn :color="themes.client.light.successButton" @click="publish">Publish</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- UNPUBLISH -->
    <v-dialog v-model="unpublishing" max-width="400px">
      <v-card>
        <v-card-title class="title"> Unpublish opportunity </v-card-title>
        <v-divider />
        <v-card-text>
          Are you sure you would like to hide the opportunity from being publicly visible?
        </v-card-text>
        <v-card-actions
          ><v-spacer />
          <v-btn flat @click="unpublishing = false" :color="themes.client.light.cancel">
            Cancel
          </v-btn>
          <v-btn :color="themes.client.light.warningButton" @click="unPublish">Unpublish</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    opportunity: Object,
    organization: Object,
  },
  data() {
    return {
      publishing: false,
      unpublishing: false,
    }
  },
  methods: {
    publish() {
      this.$store
        .dispatch(
          'client/opportunities/update',
          Object.assign(JSON.parse(JSON.stringify(this.opportunity)), {
            publishedAt: this.$date(new Date()),
          })
        )
        .then(errors => {
          if (errors) {
            this.$store.dispatch('snackbarError', 'The opportunity was not published')
          } else {
            this.$store.dispatch('snackbarSuccess', 'The opportunity was published')
          }
        })
      this.publishing = false
    },
    unPublish() {
      this.$store
        .dispatch(
          'client/opportunities/update',
          Object.assign(JSON.parse(JSON.stringify(this.opportunity)), {
            publishedAt: null,
          })
        )
        .then(errors => {
          if (errors) {
            this.$store.dispatch('snackbarError', 'The opportunity was not affected')
          } else {
            this.$store.dispatch('snackbarSuccess', 'The opportunity was unpublished')
          }
        })
      this.unpublishing = false
    },
  },
}
</script>
